import { Component, Input } from '@angular/core';
import { UITheme } from '../../../../../shared/definitions/ui-theme.enum';
import { ViewContainerBorders } from '../../../constants/view-container-borders.constant';

@Component({
  selector: 'view-container',
  standalone: false,
  templateUrl: './view-container.component.html',
  styleUrls: ['./view-container.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class ViewContainerComponent {
  @Input() width: string = '100%';
  @Input() theme: UITheme = UITheme.White;
  @Input() border: ViewContainerBorders = null;

  get classes() {
    return [this.theme, this.border ? this.border : ''].join(' ').trim();
  }
}
